// lessons/les1-motiverende-gespreksvoering/modules/Module1.js
export const MODULE1_CONFIG = {
    id: 'module1',
    title: 'Intoductie: Wat ga je leren?',
    type: 'theory',
    duration: 5,
    
    theory: {
      title: 'Introductie: Wat ga je leren?',
      sections: [
        {
          id: 'introductie',
          title: 'Introductie',
          content: `Welkom bij deze online training in motiverende gespreksvoering. Motiverende Gespreksvoering helpt je om samen met je cliënten te onderzoeken wat zij belangrijk vinden en hoe ze stappen vooruit kunnen zetten. Miller en Rollnick, de grondleggers van motiverende gespreksvoering, (2014) beschrijven het als ‘een op samenwerking gerichte, doelgerichte gespreksstijl die iemands eigen motivatie en bereidheid tot verandering versterkt.’

Binnen motiverende gespreksvoering zijn verschillende dingen van belang: de juiste volgorde van processen in een gesprek, waarden die je uitstraalt en technieken die je toepast. In deze scholing beperken we ons tot een paar basisvaardigheden die samen één geheel vormen. Zo zorgen wij er voor dat jij met meer zelfvertrouwen kan beginnen met het toepassen van motiverende gespreksvoering in de praktijk.`
        },
        {
          id: 'vaardigheden',
          title: 'De volgende vaardigheden komen aan bod',
          content: `- Verandertaal herkennen
- Open vragen stellen om het gesprek te verdiepen
- Open vragen stellen om verandertaal uit te lokken
- Reflectief luisteren
- Reflecties geven om verandertaal uit te lokken
- Technieken samenbrengen tot een natuurlijk geheel in een gesprek`
        },
        {
          id: 'aanpak',
          title: 'Hoe ga je leren?',
          content: `Elke module start met een korte uitleg over de rol van een techniek en hoe je die kunt toepassen. Daarna oefen je de vaardigheden in een rollenspel met een chatbot en krijg je gerichte feedback: zowel op de techniek zelf als op je algemene gespreksvaardigheden volgens de principes van MGV.

 Er zijn in deze training vier simulatiecliënten: Sanne, Yara, Bram en Peter. Zij hebben allemaal hun eigen hulpvraag en karakter. In iedere module oefen je met twee van de cliënten, zo leer je de vaardigheden toepassen bij verschillende personen en in verschillende situaties.
 
 Jij speelt telkens de rol van de paramedicus die de cliënt behandelt. Jouw beroep verschilt per casus. Sanne komt bij de oefentherapeut, Yara bij de huidtherapeut, Bram bij de logopedist en Peter bij de diëtist. De gesprekken gaan voornamelijk over motivatie en gedragsverandering, je hebt dus geen specifieke kennis van het beroep nodig. Uit ons onderzoek bleek juist dat het helpend kan zijn om te oefenen met casuïstiek buiten je normale beroep, omdat je minder wordt afgeleid door beroepsspecifieke kennis. Je kan je dan volledig richten op de motivatie voor gedragsverandering van je oefencliënt.

De feedback in deze training wordt automatisch gegenereerd door een AI-systeem op basis van jouw teksten. Het systeem geeft meestal heel zinvolle tips en tops waar je direct mee verder kan. We raden aan om de feedback die jou het meeste aanspreekt op te schrijven, zodat je dit mee kan nemen in de andere simulatiegesprekken, en natuurlijk ook in je werk. Soms herken je je misschien minder goed in bepaalde opmerkingen. Dat kan, want de feedback is automatisch gegenereerd en je kunt er niet over in gesprek, zoals bij een training met menselijke trainers. Het is dus van belang zelf kritisch te blijven kijken naar wat je terug krijgt van het systeem.`
        },
        {
          id: 'voorkennis',
          title: 'Voorkennis',
          content: `Deze cursus is vooral praktisch. We gaan niet uitgebreid in op de theorie van MGV, we veronderstellen dat je de basis al kent.

Ben je al goed bekend met MGV? Dan kun je door naar module 2.

Heb je minder ervaring met MGV? Dan raden we je aan om eerst de bronnen in de volgende sectie door te nemen, zodat je goed voorbereid start.

Zijn de begrippen ‘verandertaal’ en ‘behoudtaal’ nog nieuw voor je? Volg dan de optionele module ‘verandertaal herkennen’. Deze vind je onder in het dashboard.`
        },
        {
          id: 'bronnen',
          title: 'Aanbevolen bronnen',
          content: `Om een goede start te maken met deze training is het belangrijk dat je de basisprincipes van Motiverende Gespreksvoering kent. Daarom hebben we hieronder enkele bronnen verzameld die je kunt raadplegen als je je voorkennis wilt opfrissen.

Korte beschrijving motiverende gespreksvoering  
  https://www.mintned.net/wat-is-motiverende-gespreksvoering/  
  Op deze pagina vind je een korte omschrijving van motiverende gespreksvoering  
Leestijd: 5 minuten

Uitgebreide beschrijving motiverende gespreksvoering  
  https://cluster.swstatic.nl/wp-content/uploads/sites/177/2021/06/Wat-is-Motiverende-Gespreksvoering-MI-Time.pdf  
  Dit document geeft een uitgebreid overzicht van de achtergrond, ‘spirit’, technieken en processen van motiverende gespreksvoering.  
Leestijd: 15 minuten

Korte introductievideo over motiverende gespreksvoering  
  https://www.youtube.com/watch?v=74Gc8XNInFk  
  Kort maar duidelijk overzicht van motiverende gespreksvoering in 5 highlights  
Kijktijd: 6 minuten`
        }
      ]
    },
  
    completionCriteria: {
      type: 'theory_completion',
      description: 'Lees alle theorie secties door'
    },
  
    navigation: {
      nextModule: 'Naar Dashboard',
      canSkip: false
    }
  };
  
  // Content for easy access
  export const THEORY_CONTENT = MODULE1_CONFIG.theory;